import { INSIGHTS_SIMILAR_HOMES_ACTIONS } from "../../actions/insightsSimilarHomesActions";

import { TOTAL_APP_ID } from "../../constants/common";
import { cloneObject } from "../../helpers/helper";



const defaultState = {
    mode: 'SHC_BC',
    usageGraphStyle: 'Line',
    switchGasElectric: 'electric',
    dataXAxis: [],
    bcTimeStampsData: [],
    insightsSHChartsData: [],
    bcIndexOffset: 0,
    youSeriesData: [],
    averageSeriesData: [],
    efficientSeriesData: [],
    insightsDataLeftArrowDisabled: false,
    insightsDataRightArrowDisabled: true,
    currentBillingCycleInfo: '',
    isSHChartLoading: true,
    apiErrorMessage: '',
    dataNotAvailableText: '',
    bcDurations: [],
    dataEmptyText: '',
    showDisclaimerMissingInterval: false,
    showDisclaimerApplianceMissing: false,
    selectedAppliance: TOTAL_APP_ID,
    shcData: [],
    appliancesSHCList: null,
    shcChartsPayload: null
};
const insightsSimilarHomesReducer = (state = cloneObject(defaultState), action) => {
  switch (action.type) {
        case INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_API_ERROR:
            state = {
                ...state,
                apiErrorMessage: action.payload.dataNotAvailableText,
                isSHChartLoading: false,
                usageChartEvent: action.payload.usageChartEvent
            }
            break;
        case INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_DATA_NOT_AVAILABLE:
        case INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_SAVE_BILLING_CYCLE_PERIOD:
        case INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_SET_HIGHCHARTS_DATA:
        case INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_SET_ARROW_DISABLED:
        case INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_SAVE_BC_DATA:
        case INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_CHANGE_YEAR_OFFSET:
        case INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_COMPARISON_DATA:
        case INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_UPDATE_HIGHCHARTS_OBJECT:
        case INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_CHANGE_APPLIANCE:
        case INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_SAVE_APPLIANCE_NAVBAR_LIST:
        case INSIGHTS_SIMILAR_HOMES_ACTIONS.SIMILAR_HOMES_SAVE_CHART_API_PAYLOAD:
            state = {
                ...state,
                ...action.payload
            };
            break;
        case INSIGHTS_SIMILAR_HOMES_ACTIONS.RESET_DATA:
            state = cloneObject(defaultState);
            break;
        default:
            break;
  }
  return state;
};

export default insightsSimilarHomesReducer;
